export type AppBuildInfo = {
  buildId: string;
  version: string;
  builtAt: string;
  gitSha: string | null;
  shortGitSha: string | null;
  buildSource: 'env' | 'git' | 'timestamp';
};

export const APP_BUILD_INFO: AppBuildInfo = __APP_BUILD_INFO__;

export async function fetchLiveBuildInfo(): Promise<AppBuildInfo | null> {
  try {
    const response = await fetch(`/version.json?ts=${Date.now()}`, {
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache',
      },
    });

    if (!response.ok) return null;

    const data = await response.json();
    if (!data || typeof data.buildId !== 'string') return null;

    return {
      buildId: data.buildId,
      version: typeof data.version === 'string' ? data.version : '',
      builtAt: typeof data.builtAt === 'string' ? data.builtAt : '',
      gitSha: typeof data.gitSha === 'string' ? data.gitSha : null,
      shortGitSha: typeof data.shortGitSha === 'string' ? data.shortGitSha : null,
      buildSource:
        data.buildSource === 'env' ||
        data.buildSource === 'git' ||
        data.buildSource === 'timestamp'
          ? data.buildSource
          : 'timestamp',
    };
  } catch {
    return null;
  }
}
